import { type WebviewBridgeApi } from "./types";

/**
 * This utility checks properly types `window` when injected webview functions are available.
 */
export const isWebview = (
  w: Window | WebviewBridgeApi = window,
): w is WebviewBridgeApi => {
  return typeof (w as WebviewBridgeApi).sendToNative !== "undefined";
};

/**
 * Snapshot of `isWebview()` taken at module load — BEFORE the dev mock
 * potentially installs `sendToNative` on `window` via `setupMobileMock.ts`.
 * Stays `false` for a mocked dev session and `true` only when a real mobile
 * WebView injected `sendToNative` before our bundle ran.
 *
 * Package-internal — not re-exported from `index.ts`.
 */
export const isRealWebview: boolean = isWebview();
